export enum TestTypeEnum {
  MECHANICAL = 2,
  METALLOGRAPHIC = 3,
  CORROSION = 4,
  CHEMICAL = 5,
  COLLAPSE = 6,
}

export enum FilterTypeEnum {
  PROCESS_ORDER = 'PROCESS_ORDER',
  ORDER_ITEM = 'ORDER_ITEM',
  PQ = 'PQ',
}

export enum InsterpectorTypeEnum {
  I = 'generateReport.filterSection.label.internal',
  T = 'generateReport.filterSection.label.third',
}

export enum SampleTypeEnum {
  PRODUCTION = 'generateReport.filterSection.label.production',
  MPQT = 'generateReport.filterSection.label.mpqt',
  FDPT = 'generateReport.filterSection.label.fdpt',
  PD = 'generateReport.filterSection.label.pd',
}

export enum TypePermissionsReport {
  ELABORATION = 'elaborate',
  CHECK = 'check',
  APPROVE = 'approve',
  VIEW = 'view',
}
